module.exports = __webpack_public_path__ + "img/zebra.be5030ca.webp";